import { IconProps } from ".";
import Icon from "./assets/chevron_down_24.svg";
import { BaseIcon } from "./BaseIcon";

export function Icon24ChevronDown(props: IconProps) {
  return <BaseIcon icon={<Icon />} {...props} />;
}
